var _circle, _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDuploWebLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.6,
    cx: 43.9561,
    cy: 44.0439,
    r: 43.9561,
    fill: "url(#paint0_linear_17135_135556)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.4215 66.3181C32.2084 66.3181 28.7715 62.5311 28.7715 57.8889V39.8496C28.7715 35.2074 32.2084 31.4204 36.4215 31.4204C45.1432 31.4204 52.2757 39.2388 52.2757 48.8896C52.2757 58.459 45.1432 66.3181 36.4215 66.3181ZM36.4215 34.2709C33.6497 34.2709 31.3584 36.7548 31.3584 39.8496V57.8889C31.3584 60.943 33.6128 63.4676 36.4215 63.4676C43.7388 63.4676 49.6518 56.9116 49.6518 48.8896C49.6518 40.7862 43.7388 34.2709 36.4215 34.2709Z",
    fill: "#2DB49E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7397 57.3694C42.6408 57.3694 39.2969 53.5818 39.2969 48.9388V30.8964C39.2969 26.2535 42.6408 22.4658 46.7397 22.4658C55.2253 22.4658 62.1648 30.2855 62.1648 39.938C62.1288 49.509 55.2253 57.3694 46.7397 57.3694ZM46.7397 25.3168C44.043 25.3168 41.8138 27.8011 41.8138 30.8964V48.9388C41.8138 51.9934 44.0071 54.5185 46.7397 54.5185C53.859 54.5185 59.6119 47.9613 59.6119 39.938C59.6119 31.9146 53.823 25.3168 46.7397 25.3168Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_17135_135556",
    x1: 0,
    y1: 0.0878906,
    x2: 87.9121,
    y2: 88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2DB49E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#146E5F"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuploWebLogo);
export default __webpack_public_path__ + "static/media/duploWebLogo.7128cee6db859e04fee89f3775c431ab.svg";
export { ForwardRef as ReactComponent };